/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains the ProjectReport search filter component
------------------------------------------------------------------------------------------------------- */

import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import './ProjectReportSearchFilterStyle.css';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_worksite_with_pagination } from '../../../../config/Worksite/siteApis';
import CustomYearSelector from '../../../../Components/CustomYear/CustomYearSelector';
import ActionButtonWithIcon from '../../../../Components/custom_components/CustomButtons/ActionButtonWithIcon/ActionBtnWithIcon';
import { Icons } from '../../../../utils/GlobalIcons';

function ProjectReportSearchFilter({ tableTitle, searchFilter, on_change_value, on_page_count_update,

    onExportPDF,
    onExportExcel,
    isExportingPDF,
    isExportingExcel
}) {


    // Initialize with current values
    const currentYear = new Date().getFullYear();

    const [worksiteOptions, setWorksiteOptions] = useState([]);

    const fetchSites = async () => {
        try {
            const params = {
                mainSite: 0,
            }
            const response = await get_worksite_with_pagination(params);
            if (response?.status === 'success') {
                const filtered = response.data.data
                    .map(item => ({ label: item.worksiteName, value: item.WorksiteID }));
                setWorksiteOptions(filtered);
            }
        } catch (error) {
            console.error('Failed to load worksites', error);
        }
    };

    const formik = useFormik({
        initialValues: {
            // technology: '',
            year: currentYear,
            parent_site_id: ''
        },

    });

    useEffect(() => {
        fetchSites();
    }, []);


    const resetFilter = () => {
        // on_change_value(1)
        // on_page_count_update(25)
        searchFilter({
            // technology: '',
            year: currentYear,
            parent_site_id: ''
        })
        formik.setValues({
            // technology: '',
            year: currentYear,
            parent_site_id: ''
        });
    };

    const breadcrumbs = ['Reports', tableTitle]

    return (
        <div className="technology-lookup-search-container">
            <div className="technology-lookup-search-sub-container">
                <div className="technology-lookup-search-header">
                    <div className="technology-lookup-search-left">
                        <div className="technology-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="common-export-buttons-container">
                        <ActionButtonWithIcon
                            label="Export PDF"
                            onClick={onExportPDF}
                            icon={Icons.PdfIcon}
                            backgroundColor="#ffffff"
                            hoverColor="#fef2f2"
                            labelColor="#000000"
                            borderColor="#e5e7eb"
                            iconColor="#dc2626"
                            loading={isExportingPDF}
                        />

                        <ActionButtonWithIcon
                            label="Export Excel"
                            onClick={onExportExcel}
                            icon={Icons.ExcelIcon}
                            backgroundColor="#ffffff"
                            hoverColor="#f0fdf4"
                            labelColor="#000000"
                            borderColor="#e5e7eb"
                            iconColor="#16a34a"
                            loading={isExportingExcel}
                        />
                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            <Grid item xs={12} sm={6} md={3}>
                                <CustomSelectDropdown
                                    name="parent_site_id"
                                    placeholder="Select Main Site"
                                    options={worksiteOptions}
                                    value={worksiteOptions.find(opt => opt.value === formik.values.parent_site_id) || ''}
                                    onChange={opt => formik.setFieldValue('parent_site_id', opt?.value || '')}
                                    onBlur={formik.handleBlur}
                                    isMulti={false}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomYearSelector initialYear={2025} formik={formik} />
                            </Grid>


                        </div>
                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    // on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectReportSearchFilter;
